import React from 'react';

function DirectoryNavigationHeader({
  resultCount = 0,
  searchQuery = '',
}) {
  return null;
}

export default DirectoryNavigationHeader;
